import React from 'react';
import { getRecipients, getBySaleId, getRecipientsPaginated } from '../../api/giftApi';
import { connect } from 'react-redux';
import { Redirect } from "react-router-dom";
import { handleDropDownClick, formatDateFields } from '../../helpers';
import SearchBar from '../SearchBar';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { updateRedirect } from './../../helpers/redirect';
import '../css/View.css';
import ReportTypes from '../reports/reportTypes'
import DataTableBase from '../utils/DataTable';

class GiftView extends React.Component {
    constructor(props) {
        super(props);
        let filterValue = '';
        this.table = React.createRef();

        const { reset, purchaseId } = this.updateNavigation();

        this.state = {
            data: [],
            page: 0,
            recipient: { enrollment: {} },
            loading: true,
            value: filterValue,
            edit: false,
            moreOptions: [],
            filter: '',
            item: '',
            reset: reset,
            redirectToReport: false,
            totalRows: 0,
            perPage: 10,
            orderBy: '',
            descending: false,
            defaultPage: 1
        }

        this.filterSearch = this.filterSearch.bind(this);
        this.handleEdit = this.handleEdit.bind(this);
        this.fetchData = this.fetchData.bind(this);
        this.redirectDropdown = this.redirectDropdown.bind(this);
        this.stateSettingClosed = this.stateSettingClosed.bind(this);
        this.stateSettingOpened = this.stateSettingOpened.bind(this);
        this.handlePerRowsChange = this.handlePerRowsChange.bind(this);
        this.handlePageChange = this.handlePageChange.bind(this);
        this.handleSort = this.handleSort.bind(this);
    }

    updateNavigation() {
        if (!this.itIsCalledFromSales)
            return { reset: false, purchaseId: '' };

        const purchaseId = this.props.route.location.state.saleId;
        this.props.route.history.push('/secure/sales');
        this.props.route.history.push({
            pathname: this.props.route.match.url,
            state: { saleId: purchaseId }
        });

        return { reset: true, purchaseId: purchaseId };
    }

    get itIsCalledFromSales() {
        if (this.props.route.location.state && this.props.route.location.state.from === 'sales')
            return true
        return false
    }

    componentDidMount() {
        this.setState({
            loading: true,
        })
        this.fetchData(this.state.value, 0)
    }

    componentDidUpdate() {
        if (this.state.reset && this.props.route.location.state === undefined) {
            this.setState({
                loading: true,
                value: '',
                reset: false
            })
            this.fetchData(this.state.value, 0);
        }
    }

    //Change the index for the column you SHOULDNT be CLICKABLE
    handleEdit(recipient) {
        this.setState({
            edit: true,
            recipient: recipient
        })
    }

    filterSearch(event) {
        var value = event.target.value;
        if (event.key === 'Enter' || !value) {
            this.fetchData(value, 0);
            this.setState({
                page: 0,
                loading: true,
                value: value
            })
        }
    }

    getData(data, _this) {
        if (data.data.data) {
            var length = data.data.data.length;
            var p = <p className="cursor closed">
                <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
            </p>;
            var moreOptions = [];
            for (let x = 0; x < length; x++) {
                moreOptions.push(p)
            }
            _this.setState({
                page: 1,
                data: data.data.data,
                pages: 1,
                moreOptions: moreOptions,
                loading: false
            })
        }
        else {
            _this.setState({
                data: [],
                moreOptions: [],
                loading: false
            })
        }
    }

    fetchData(filterValue, page) {
        if (this.state.reset && filterValue !== true)
            this.state.reset = false
        if (!this.state.reset || filterValue === true) {
            if (filterValue === true) filterValue = ''
            var p = <p className="cursor closed" >
                <FontAwesomeIcon icon="bars" size="2x" color="#28A745" />
            </p>;
            if (typeof filterValue === 'object')
                filterValue = this.state.value;
            if (page === undefined)
                page = this.state.page;
            this.setState({ loading: true, error: false });

            var saleId = 0;
            if (this.props.route.location.state)
                saleId = this.props.route.location.state.saleId
            getRecipientsPaginated(filterValue, page, this.state.perPage, this.state.orderBy, this.state.descending, saleId)
                .then((res) => {
                    var moreOptions = [];
                    for (let x = 0; x < res.data.data.results.length; x++) {
                        moreOptions.push(p)
                    }
                    this.setState({
                        data: res.data.data.results,
                        totalRows: res.data.data.rowCount,
                        pages: res.data.data.pageCount,
                        moreOptions: moreOptions,
                        loading: false
                    })
                }).catch((err) => {
                    var errorList = [];
                    err.response.data.errors.map(function (e) { errorList.push(e.message) });

                    this.setState({
                        data: [],
                        error: true,
                        loading: false,
                        errorMessage: errorList
                    })
                });
        }
    }

    redirectDropdown(item, row) {
        let filter;
        switch (item) {
            case "Sale":
                var route = <Redirect
                    to={{
                        pathname: `/secure/saleEdit/${row.saleId}`,
                        state: { from: 'gift' }
                    }} />;
                filter = row.saleId
                break;

            case "Product":
                var route = <Redirect
                    to={{
                        pathname: `/secure/productHistoryEdit/${row.productHistoryId}`,
                        state: { from: 'gift' }
                    }}
                />;
                filter = row.productHistoryId
                break;
        }
        this.setState({
            dropdownClicked: true,
            giftFilter: filter,
            route: route,
            selected: `${item}s`
        })
    }

    //Parent setting state to pass as props to child function for dropdown
    stateSettingClosed(moreOpts) {
        this.setState({
            moreOptions: moreOpts,
        })
    }

    //Parent setting state to pass as props to child function for dropdown
    stateSettingOpened(moreOpts) {
        this.setState({
            moreOptions: moreOpts,
        })
    }

    handlePerRowsChange(newPerPage, page) {
        this.setState({ perPage: newPerPage }, () => {
            this.fetchData(this.state.value, page)
        });
    }

    handlePageChange(page) {
        if (this.isSorting) return;
        this.fetchData(this.state.value, page);
    }

    handleSort(column) {
        this.isSorting = true;
        this.setState({ descending: !this.state.descending, orderBy: column.sortField }, () => {
            this.fetchData(this.state.value, 0)
            this.isSorting = false;
        });
    }

    render() {
        //List of items to pass to the dropdown as <a>
        let items = ["Product", "Sale"];

        //Name of component to pass to the dropdown to indentify dropdown className
        var component = "recipients";

        if (this.state.redirectToReport)
            return <Redirect to={{ pathname: '/secure/gift/report', state: { report: ReportTypes.SalesReport } }} push={true} />

        if (this.state.edit) {
            return <Redirect
                to={{
                    pathname: `/secure/giftEdit/${this.state.recipient.recipientId}`,
                    state: { recipient: this.state.recipient }
                }}
            />;
        }

        if (this.state.dropdownClicked) {
            this.props.currentNavigationConnect({
                isOpen: false,
                selected: this.state.selected.toLowerCase(),
                selectedAdmin: ''
            });


            return this.state.route;
        }



        const columns = [
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 170,
                        }}
                    >
                        Last name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '170',
                selector: row => row.firstName,
                sortable: true,
                sortField: 'lastName',
                cell: row => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.lastName}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 170,
                        }}
                    >
                        First name <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '170',
                selector: row => row.firstName,
                sortable: true,
                sortField: 'firstName',
                cell: row => <div onClick={() => this.handleEdit(row)}><p className="cursor">{row.firstName}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 220,
                        }}
                    >
                        Email <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '220px',
                selector: row => row.clubName,
                sortable: true,
                sortField: 'email',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{row.email}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 120,
                        }}
                    >
                        Status <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '120px',
                selector: row => row.telephone,
                sortable: true,
                sortField: 'giftStatus',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{row.giftStatus}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 120,
                        }}
                    >
                        Delivery Date <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '120px',
                selector: row => row.deliveryDate,
                sortable: true,
                sortField: 'deliveryDate',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{!row.deliveryDate ? "" : formatDateFields(row.deliveryDate)}</p></div>
            },
            {
                name:
                    <div
                        style={{
                            textAlign: "left",
                            width: 130,
                        }}
                    >
                        Expiration Date <FontAwesomeIcon icon="sort" size="sm" />
                    </div>,
                width: '130px',
                selector: row => row.expirationDate,
                sortable: true,
                sortField: 'expirationDate',
                cell: row => <div role="link" onClick={() => this.handleEdit(row)}><p className="cursor">{!row.expirationDate ? "" : formatDateFields(row.expirationDate)}</p></div>
            },
            {
                //options header
                name:
                    <div
                        style={{
                            textAlign: 'center',
                        }}
                    >
                        Options
                    </div>,
                center: true,
                style: { justifyContent: 'center' },
                width: '100px',
                //options row
                cell: (row, index, column) => (
                    <div
                        onClick={ev =>
                            handleDropDownClick(
                                ev,
                                index,
                                this.state.moreOptions,
                                this.stateSettingClosed,
                                this.stateSettingOpened,
                                items,
                                component,
                                this.redirectDropdown,
                                row
                            )
                        }
                    >
                        {this.state.moreOptions[index]}
                    </div>
                ),
            },
        ]

        return (
            <div >
                <SearchBar
                    onKeyUp={this.filterSearch}
                    onClick={this.filterSearch}
                    onChange={this.filterSearch}
                />

                <DataTableBase
                    columns={columns}
                    isLoading={this.state.loading}
                    data={this.state.data}
                    paginationTotalRows={this.state.totalRows}
                    paginationPerPage={this.state.perPage}
                    paginationDefaultPage={this.state.defaultPage}
                    onChangeRowsPerPage={this.handlePerRowsChange}
                    onChangePage={this.handlePageChange}
                    onSort={this.handleSort}
                />

                <button onClick={() => this.setState({ redirectToReport: true })} className="btn mt-4">Reports</button>
            </div>
        );
    }
}

export default connect(
    null,
    dispatch => ({
        getRecipients: (callback, context, filter) => { dispatch(getRecipients(callback, context, filter)) },
        currentNavigationConnect: (response) => { dispatch(updateRedirect(response)) },
        getBySaleId: (callback, context, filter) => { dispatch(getBySaleId(callback, context, filter)) }

    }))(GiftView);


